import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxRotateNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M8.636 20.764C8.636 21.0954 8.3674 21.364 8.036 21.364H2.636L8.636 15.364V20.764Z"
        fill={color}
      />
      <path
        d="M15.364 3.23599C15.364 2.90459 15.6326 2.63599 15.964 2.63599H21.364L15.364 8.63599V3.23599Z"
        fill={color}
      />
      <path
        d="M18.1195 3.84021L16.6805 5.75981C18.6633 7.24811 19.8 9.52271 19.8 12H22.2C22.2 8.76091 20.714 5.78671 18.1195 3.84021Z"
        fill={color}
      />
      <path
        d="M19.8 12C19.8 16.3008 16.3008 19.8 12 19.8V22.2C17.625 22.2 22.2 17.625 22.2 12H19.8Z"
        fill={color}
      />
      <path
        d="M4.2 12H1.8C1.8 15.2414 3.2871 18.2156 5.8793 20.1609L7.3206 18.239C5.3367 16.753 4.2 14.4774 4.2 12Z"
        fill={color}
      />
      <path
        d="M1.8 12H4.2C4.2 7.69919 7.6992 4.19999 12 4.19999V1.79999C6.3762 1.79999 1.8 6.37619 1.8 12Z"
        fill={color}
      />
      <path
        d="M13.6769 11.5507C13.139 9.54309 13.2424 7.36359 13.2424 7.36359C13.2424 7.36359 12.2422 9.30279 10.7725 10.7725C9.3028 12.2422 7.3636 13.2424 7.3636 13.2424C7.3636 13.2424 9.5431 13.139 11.5507 13.6769C13.5583 14.2149 15.3941 15.3942 15.3941 15.3942C15.3941 15.3942 14.2149 13.5583 13.6769 11.5507Z"
        fill={color}
      />
      <path
        d="M13.6769 11.5507C13.139 9.54309 13.2424 7.36359 13.2424 7.36359C13.2424 7.36359 12.2422 9.30279 10.7725 10.7725C9.3028 12.2422 7.3636 13.2424 7.3636 13.2424C7.3636 13.2424 9.5431 13.139 11.5507 13.6769C13.5583 14.2149 15.3941 15.3942 15.3941 15.3942C15.3941 15.3942 14.2149 13.5583 13.6769 11.5507Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolboxRotateNsk.displayName = 'ToolboxRotateNsk';
